import React, { useState } from 'react';
import './WhatsAppButton.css';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { SITE } from '../config/site';

const WhatsAppButton = () => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  const whatsappNumber = SITE.whatsappDigits;
  const whatsappMessage = language === 'ar' 
    ? 'مرحباً، أود التواصل بخصوص MASAR | مسار' 
    : language === 'tr'
    ? 'Merhaba, MASAR hakkında bilgi almak istiyorum'
    : 'Hello, I would like to reach MASAR regarding partnerships or services';
  
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  
  const tooltipText = language === 'ar'
    ? 'تواصل معنا على واتساب'
    : language === 'tr'
    ? 'WhatsApp ile bize ulaşın'
    : 'Contact us on WhatsApp';

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-button ${theme}`}
      aria-label="Contact us on WhatsApp"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="whatsapp-icon-wrapper">
        <i className="fab fa-whatsapp"></i>
      </div>
      {isHovered && (
        <div className="whatsapp-tooltip">
          <span>{tooltipText}</span>
        </div>
      )}
      <div className="whatsapp-pulse"></div>
    </a>
  );
};

export default WhatsAppButton;

